// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.box {
  border-radius: 15px;
  padding: 1rem;
  margin: 15px;
  background-color: white;
  box-shadow: 0 0px 5px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.btnBox {
  display: flex;
  flex-direction: row;
}

.btnBoxClient {
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  width: 35px;
  height: 35px;
  border-radius: 50px;
  margin: 3%;
}

.stringBox {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  padding-left: 1%;
  padding-right: 1%;
}

.clientStringBox {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  padding: 15px;
}

.stringBox p {
  margin-top: auto;
  margin-bottom: auto;
}

.addAbonnement {
  background-color: #4C57CF;
  border-radius: 50%;
}

.abonnement {
  margin: 0.3rem;
  background-color: #f7f7f7;
  padding: 1rem;
  border-radius: 5px;
}

p {
  color: black;
}

.detailsContainer {
  transition: height 0.3s ease;
  overflow: hidden;
}

.detailsContainer.active {
  height: auto;
}

.clientBox {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  flex: 0 0 auto;
  margin-right: 0.5rem;
  height: 4rem;
  width: 4rem;
  border-radius: 80px;
  cursor: pointer;
  color: white;
  position: absolute;
  left: 50%;
  top: -20%;
  transform: translate(-50%);
}

.pagination {
  border: rgb(53, 53, 53) solid 1px;
  width: 2rem;
  height: 2rem;
  border-radius: 100%;
}

ion-fab-button {
  --box-shadow: none;
  --color: #4C57CF;
  --background: none;
  --border-color: #4C57CF;
  --border-width: 1px;
  --border-style: solid;
}

ion-button {
  --background: #4C57CF;
  --color: white;
  text-transform: none;
  width: 50%;
  margin: auto;
}

.session-header h2 {
  margin: 0;
  font-size: 1.2em;
}

.session-body {
  padding: 15px;
}

.session-details {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.session-date {
  display: flex;
  align-items: center;
  font-size: 0.9em;
  color: #555;
  justify-content: space-evenly;
}

.session-date ion-icon {
  margin-right: 5px;
  color: #007bff;
  font-size: 1.5rem;
}

.session-note {
  font-size: 1em;
  color: #333;
}

.sessionBox {
  background: #f9f9f9;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.3s ease;
}

.backgroundTab {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  border-radius: 30px;
  transition: transform 0.3s ease;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}

.session {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 7rem; /* Ajustez la largeur selon vos besoins */
  border-radius: 30px;
  color: #333; /* Couleur du texte par défaut (bleu) */
  transition: color 0.3s ease; /* Ajoutez une transition pour la couleur du texte */
  font-size: 13px;
  z-index: 3;
  padding: 5px;
}

.selected {
  color: #007bff;
  transition: color 0.3s ease;
}

.position {
  transform: translateX(100%); /* Déplacez la backgroundTab à droite de 100% de sa largeur */
}

ion-segment-button {
  white-space: normal;
  text-align: center;
  font-size: 10px;
  padding: 6px;
}

ion-segment {
  background-color: white;
  border-radius: 10px;
  margin: auto;
  width: 98%;
}

.abonnement-card {
  border-bottom: 1px solid #ddd;
  padding: 12px;
  background-color: #fff;
}
.abonnement-card .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.abonnement-card .header .formule-name {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}
.abonnement-card .header .toggle-icon {
  font-size: 20px;
  color: #000;
}
.abonnement-card .details-card {
  background-color: #f9f9f9;
  margin-top: 10px;
  border-radius: 10px;
}
.abonnement-card .details-card .info-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #eaeaea;
}
.abonnement-card .details-card .info-row .label {
  font-weight: 500;
  color: #555;
}
.abonnement-card .details-card .info-row .value {
  font-weight: 600;
  color: #000;
}
.abonnement-card .details-card .btn-group {
  width: 100%;
  margin-top: 15px;
}
.abonnement-card .details-card .btn-group ion-button {
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/client/page-client/page-client.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,iFAAA;AAEF;;AAAA;EACE,aAAA;EACA,mBAAA;AAGF;;AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;AAGF;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAGF;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AAGF;;AAAA;EACE,gBAAA;EACA,mBAAA;AAGF;;AAAA;EACE,yBAAA;EACA,kBAAA;AAGF;;AAAA;EACI,cAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;AAGJ;;AAAA;EACE,YAAA;AAGF;;AAAA;EACE,4BAAA;EACA,gBAAA;AAGF;;AAAA;EACE,YAAA;AAGF;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,0BAAA;AAGF;;AAAA;EACE,iCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAGF;;AAAA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AAGF;;AAAA;EACE,qBAAA;EACA,cAAA;EACA,oBAAA;EACA,UAAA;EACA,YAAA;AAGF;;AAGA;EACE,SAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,6BAAA;AAAF;;AAGA;EACE,iBAAA;EACA,cAAA;EACA,iBAAA;AAAF;;AAIA;EACE,cAAA;EACA,WAAA;AADF;;AAIA;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;EACA,gBAAA;EACA,+BAAA;AADF;;AAMA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,+BAAA;EACA,iDAAA;AAHF;;AAOA;EACE,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA,EAAA,yCAAA;EACA,mBAAA;EACA,WAAA,EAAA,uCAAA;EACA,2BAAA,EAAA,oDAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;AAJF;;AAOA;EACE,cAAA;EACA,2BAAA;AAJF;;AAOA;EACE,2BAAA,EAAA,6DAAA;AAJF;;AAOA;EACE,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAJF;;AAOA;EACM,uBAAA;EACF,mBAAA;EACA,YAAA;EACA,UAAA;AAJJ;;AASA;EACE,6BAAA;EACA,aAAA;EACA,sBAAA;AANF;AAQE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AANJ;AAQI;EACE,eAAA;EACA,gBAAA;EACA,SAAA;AANN;AASI;EACE,eAAA;EACA,WAAA;AAPN;AAWE;EACM,yBAAA;EACJ,gBAAA;EACA,mBAAA;AATJ;AAWI;EACE,aAAA;EACA,8BAAA;EACA,cAAA;EACA,gCAAA;AATN;AAWM;EACE,gBAAA;EACA,WAAA;AATR;AAYM;EACE,gBAAA;EACA,WAAA;AAVR;AAcI;EACE,WAAA;EACA,gBAAA;AAZN;AAcM;EACE,eAAA;AAZR","sourcesContent":[".box {\r\n  border-radius: 15px;\r\n  padding: 1rem;\r\n  margin: 15px;\r\n  background-color: white;\r\n  box-shadow:  0 0px 5px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\r\n}\r\n.btnBox{\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n.btnBoxClient{\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: white;\r\n  width: 35px; \r\n  height: 35px;  \r\n  border-radius: 50px;\r\n  margin: 3%;\r\n}\r\n\r\n.stringBox {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  text-align: center;\r\n  padding-left: 1%;\r\n  padding-right: 1%;\r\n}\r\n\r\n.clientStringBox {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  text-align: center;\r\n  padding: 15px;\r\n}\r\n\r\n.stringBox p {\r\n  margin-top: auto;\r\n  margin-bottom: auto;\r\n}\r\n\r\n.addAbonnement {\r\n  background-color: #4C57CF;\r\n  border-radius: 50%;\r\n}\r\n\r\n.abonnement{\r\n    margin: 0.3rem;\r\n    background-color: #f7f7f7;\r\n    padding: 1rem;\r\n    border-radius: 5px;\r\n}\r\n\r\np {\r\n  color: black;\r\n}\r\n\r\n.detailsContainer {\r\n  transition: height 0.3s ease;\r\n  overflow: hidden;\r\n}\r\n\r\n.detailsContainer.active {\r\n  height: auto;\r\n}\r\n\r\n.clientBox {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0.5rem;\r\n  flex: 0 0 auto;\r\n  margin-right: 0.5rem;\r\n  height: 4rem;\r\n  width: 4rem;\r\n  border-radius: 80px;\r\n  cursor: pointer;\r\n  color: white;\r\n  position: absolute;\r\n  left: 50%;\r\n  top: -20%;\r\n  transform: translate(-50%);\r\n}\r\n\r\n.pagination{\r\n  border: rgb(53, 53, 53) solid 1px;\r\n  width: 2rem;\r\n  height: 2rem;\r\n  border-radius: 100%;\r\n}\r\n\r\nion-fab-button{\r\n  --box-shadow: none;\r\n  --color: #4C57CF;\r\n  --background : none;\r\n  --border-color : #4C57CF;\r\n  --border-width : 1px;\r\n  --border-style: solid;\r\n}\r\n\r\nion-button{\r\n  --background: #4C57CF;\r\n  --color : white;\r\n  text-transform: none;\r\n  width: 50%;\r\n  margin: auto;\r\n}\r\n\r\n//SESSION\r\n\r\n\r\n.session-header h2 {\r\n  margin: 0;\r\n  font-size: 1.2em;\r\n}\r\n\r\n.session-body {\r\n  padding: 15px;\r\n}\r\n\r\n.session-details {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.session-date {\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 0.9em;\r\n  color: #555;\r\n  justify-content: space-evenly;\r\n}\r\n\r\n.session-date ion-icon {\r\n  margin-right: 5px;\r\n  color: #007bff;\r\n  font-size: 1.5rem;\r\n  \r\n}\r\n\r\n.session-note {\r\n  font-size: 1em;\r\n  color: #333;\r\n}\r\n\r\n.sessionBox {\r\n  background: #f9f9f9;\r\n  border-radius: 8px;\r\n  margin-bottom: 20px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  overflow: hidden;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n\r\n\r\n.backgroundTab {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 50%; \r\n  height: 100%;\r\n  border-radius: 30px;\r\n  transition: transform 0.3s ease; \r\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\r\n}\r\n\r\n\r\n.session {\r\n  flex: 1;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  width: 7rem; /* Ajustez la largeur selon vos besoins */\r\n  border-radius: 30px;\r\n  color: #333; /* Couleur du texte par défaut (bleu) */\r\n  transition: color 0.3s ease; /* Ajoutez une transition pour la couleur du texte */\r\n  font-size: 13px;\r\n  z-index: 3;\r\n  padding: 5px;\r\n}\r\n\r\n.selected {\r\n  color: #007bff;\r\n  transition: color 0.3s ease;\r\n}\r\n\r\n.position {\r\n  transform: translateX(100%); /* Déplacez la backgroundTab à droite de 100% de sa largeur */\r\n}\r\n\r\nion-segment-button {\r\n  white-space: normal;\r\n  text-align: center;\r\n  font-size: 10px;\r\n  padding: 6px;\r\n}\r\n\r\nion-segment{\r\n      background-color: white;\r\n    border-radius: 10px;\r\n    margin: auto;\r\n    width: 98%;\r\n}\r\n\r\n\r\n//Abonnement\r\n.abonnement-card {\r\n  border-bottom: 1px solid #ddd;\r\n  padding: 12px;\r\n  background-color: #fff;\r\n\r\n  .header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    cursor: pointer;\r\n\r\n    .formule-name {\r\n      font-size: 16px;\r\n      font-weight: 600;\r\n      margin: 0;\r\n    }\r\n\r\n    .toggle-icon {\r\n      font-size: 20px;\r\n      color: #000;\r\n    }\r\n  }\r\n\r\n  .details-card {\r\n        background-color: #f9f9f9;\r\n    margin-top: 10px;\r\n    border-radius: 10px;\r\n\r\n    .info-row {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      padding: 8px 0;\r\n      border-bottom: 1px solid #eaeaea;\r\n\r\n      .label {\r\n        font-weight: 500;\r\n        color: #555;\r\n      }\r\n\r\n      .value {\r\n        font-weight: 600;\r\n        color: #000;\r\n      }\r\n    }\r\n\r\n    .btn-group {\r\n      width: 100%;\r\n      margin-top: 15px;\r\n\r\n      ion-button {\r\n        margin-top: 8px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
